module.exports = __webpack_public_path__ + "0724e75f12ba8498152ae7fab0de22ea.png";